import { FC } from 'react';
import { NavLinkWithCopyText } from '../NavLinkWithCopyText';
import { Tooltip } from '../Tooltip';
import { formatTransactionType, numberFormatting } from '../../helpers/formats';
import { formatTimestamp } from '../../helpers/time';
import { useAppParams } from '../../hooks/useAppParams';
import { useTransactionType } from '../../hooks/useTransactionType';
import { ITransaction } from '../../types/transaction';
import styles from './index.module.scss';
import { bigIntDecimalsDivision, bigIntFormat } from '../../helpers/bignumber';

export const TransactionRow: FC<ITransaction> = ({
  errorMessage,
  transaction,
  timestamp,
  senderRS,
  recipientRS,
  type,
  subtype,
  attachment,
  amountATM,
  feeATM,
}) => {
  const params = useAppParams();
  const { transactionType, currencyCode, currencyTotal } = useTransactionType({
    type,
    subtype,
    attachment,
  });

  const handleFormatNumber = (num: string | null) =>
    typeof num === 'string'
      ? numberFormatting(num, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : num;

  const currentPath = params.code
    ? `/transactions/currency/${params.code}/${transaction}`
    : params.account
    ? `/transactions/accountId/${params.account}/${transaction}`
    : `/transactions/${transaction}`;

  return (
    <tr>
      <td>
        {errorMessage ? (
          <div className='d-flex'>
            <NavLinkWithCopyText path={currentPath} text={transaction} />
            <Tooltip classNameWrapper={styles.tooltipWrapper}>
              <div>Transaction FAILED</div>
            </Tooltip>
          </div>
        ) : (
          <NavLinkWithCopyText path={currentPath} text={transaction} />
        )}
      </td>
      <td>
        {transactionType === 'CurrencyTransfer'
          ? handleFormatNumber(currencyTotal)
          : handleFormatNumber(bigIntFormat(bigIntDecimalsDivision(amountATM, 8)))}
      </td>
      <td>{currencyCode ?? 'APL'}</td>
      <td>{bigIntFormat(bigIntDecimalsDivision(feeATM, 8))}</td>
      <td>{formatTimestamp(timestamp)}</td>
      <td>{formatTimestamp(timestamp - 7200)}</td>
      <td>
        <NavLinkWithCopyText path={`/accounts/${senderRS}`} text={senderRS} />
      </td>
      <td>
        {recipientRS ? (
          <NavLinkWithCopyText path={`/accounts/${recipientRS}`} text={recipientRS} />
        ) : (
          '-'
        )}
      </td>
      <td>{formatTransactionType(transactionType || '')}</td>
    </tr>
  );
};
